import { DARK_MODE, SIDEBAR_COLLAPSED } from "../constants";
  
const initialState = {
  isDarkMode: false,
  isSideBarCollapsed: false
};
  
export default function commonReducer(state = initialState, action) {
  switch (action.type) {
  case DARK_MODE:
    return {
      ...state,
      isDarkMode: action.checked,
    };
  case SIDEBAR_COLLAPSED:
    return {
      ...state,
      isSideBarCollapsed: !state.isSideBarCollapsed,
    };
  default:
    return state;
  }
}
  